module.exports = __webpack_public_path__ + "img/experience15.eee14266.png";